const hasSafeKeyword = (keywords = '') => {
    const safeKeywords = ['习近平', '新时代'];
    return safeKeywords.reduce((result, keyword) => {
        if (result) {
            return result;
        } else {
            return keywords.includes(keyword);
        }
    }, false)
        ? true
        : false;
};

export default hasSafeKeyword;
